import { Property } from '@/types/property';
import PropertyDisplay from './PropertyDisplay';

interface PropertyCardProps {
  property: Property;
  variant?: 'card' | 'popup';
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
  showButton?: boolean;
  buttonText?: string;
}

export default function PropertyCard({
  property,
  variant = 'card',
  onMouseEnter,
  onMouseLeave,
  onClick,
  showButton = false,
  buttonText
}: PropertyCardProps) {
  return (
    <PropertyDisplay
      property={property}
      variant={variant}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      showButton={showButton}
      buttonText={buttonText}
    />
  );
}